const LURED = [
  { name: 'Finance', delivered: 24, hits: 6, deep: 2 },
  { name: 'Sales', delivered: 28, hits: 3, deep: 1 },
  {
    name: 'Other (small teams)',
    delivered: 14,
    hits: 2,
    deep: 1,
    aggregateOf: ['Legal', 'Facilities'],
  },
  { name: 'Marketing', delivered: 18, hits: 2, deep: 0 },
  { name: 'Operations', delivered: 22, hits: 1, deep: 0 },
  { name: 'Support', delivered: 26, hits: 1, deep: 0 },
  { name: 'Product', delivered: 30, hits: 1, deep: 0 },
  { name: 'IT', delivered: 38, hits: 0, deep: 0 },
  { name: 'HR', delivered: 20, hits: 0, deep: 0 },
  { name: 'Engineering', delivered: 12, hits: 0, deep: 0 },
]

const REPORTING = [
  { name: 'IT', delivered: 38, hits: 12, deep: 0 },
  { name: 'HR', delivered: 20, hits: 8, deep: 0 },
  { name: 'Support', delivered: 26, hits: 6, deep: 0 },
  { name: 'Engineering', delivered: 12, hits: 5, deep: 0 },
  { name: 'Product', delivered: 30, hits: 5, deep: 0 },
  { name: 'Operations', delivered: 22, hits: 4, deep: 0 },
  { name: 'Marketing', delivered: 18, hits: 3, deep: 0 },
  { name: 'Finance', delivered: 24, hits: 2, deep: 0 },
  { name: 'Sales', delivered: 28, hits: 1, deep: 0 },
  {
    name: 'Other (small teams)',
    delivered: 14,
    hits: 0,
    deep: 0,
    aggregateOf: ['Legal', 'Facilities'],
  },
]

export const simulationDepartmentOutcomesFixture = (campaignId) => ({
  id: Number(campaignId) || 27,
  available: true,
  phase: 'collecting',
  vector: 'dataEntry',
  fileFormat: null,
  delivered: 232,
  scheduled: 240,
  lured: LURED,
  reporting: REPORTING,
})
